/* nopeヘッダー。ドロワーメニューの開閉、フォーカストラップ、スクロール固定、Escキー対応を行う。 */
(function () {
  "use strict";

  var OPEN = "data-open";
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function initInstance(root) {
    if (!root || root.dataset.nopeInit === "true") return;

    var toggle = root.querySelector(".header-nope__toggle");
    var overlay = root.querySelector(".header-nope__overlay");
    var panel = root.querySelector(".header-nope__panel");
    var closeBtn = root.querySelector(".header-nope__close");
    var scrim = root.querySelector(".header-nope__scrim");

    // 必要な要素がない場合は、エラーにせず初期化を中止する。
    if (!toggle || !overlay || !panel) return;
    root.dataset.nopeInit = "true";

    var isOpen = false;
    var lastFocused = null;
    var scrollY = 0;
    var bar = root.querySelector(".header-nope__bar");

    // ドロワー表示中、パネル外のコンテンツをフォーカス/支援技術の対象から外す。
    function setBackgroundInert(value) {
      if (!("inert" in HTMLElement.prototype)) return;
      var targets = [document.getElementById("main"), bar];
      targets.forEach(function (el) {
        if (el) el.inert = value;
      });
    }

    function focusable() {
      return Array.prototype.slice.call(panel.querySelectorAll(FOCUSABLE)).filter(function (el) {
        return el.offsetParent !== null;
      });
    }

    function lockScroll() {
      scrollY = window.scrollY || window.pageYOffset || 0;
      document.body.style.position = "fixed";
      document.body.style.top = "-" + scrollY + "px";
      document.body.style.left = "0";
      document.body.style.right = "0";
      document.body.style.width = "100%";
    }

    function unlockScroll() {
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      document.body.style.width = "";
      window.scrollTo(0, scrollY);
    }

    function onKeydown(event) {
      if (event.key === "Escape" || event.keyCode === 27) {
        event.preventDefault();
        close();
        return;
      }
      if (event.key !== "Tab" && event.keyCode !== 9) return;

      var items = focusable();
      if (items.length === 0) return;

      var first = items[0];
      var last = items[items.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function open() {
      if (isOpen) return;
      isOpen = true;
      lastFocused = document.activeElement;

      overlay.classList.add("is-active");
      // パネルの閉じた状態からトランジションを開始するため、再描画を強制する。
      void overlay.offsetWidth;

      overlay.setAttribute(OPEN, "true");
      overlay.setAttribute("aria-hidden", "false");
      toggle.setAttribute("aria-expanded", "true");

      lockScroll();
      setBackgroundInert(true);
      (closeBtn || focusable()[0] || panel).focus({ preventScroll: true });
      document.addEventListener("keydown", onKeydown);
    }

    function close() {
      if (!isOpen) return;
      isOpen = false;

      overlay.setAttribute(OPEN, "false");
      overlay.setAttribute("aria-hidden", "true");
      toggle.setAttribute("aria-expanded", "false");

      document.removeEventListener("keydown", onKeydown);
      setBackgroundInert(false);
      unlockScroll();

      if (lastFocused && typeof lastFocused.focus === "function") {
        lastFocused.focus({ preventScroll: true });
      }
    }

    // 閉じるアニメーションが終わったらオーバーレイを隠し、アクセシビリティツリーから外す。
    panel.addEventListener("transitionend", function (event) {
      if (event.target !== panel) return;
      if (event.propertyName !== "transform" && event.propertyName !== "opacity") return;
      if (overlay.getAttribute(OPEN) !== "true") {
        overlay.classList.remove("is-active");
      }
    });

    toggle.addEventListener("click", open);
    if (closeBtn) closeBtn.addEventListener("click", close);
    if (scrim) scrim.addEventListener("click", close);
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll(".header-nope");
    Array.prototype.forEach.call(nodes, initInstance);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll();
    });
  } else {
    initAll();
  }

  // テーマエディタでセクションが再描画された時に、もう一度初期化する。
  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
